// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminRegion } from './AdminRegion';
import {
  AdminRegionFromJSON,
  AdminRegionFromJSONTyped,
  AdminRegionToJSON,
  AdminRegionToJSONTyped,
} from './AdminRegion';

/**
 *
 * @export
 * @interface MarkRegionAvailable200Response
 */
export interface MarkRegionAvailable200Response {
  /**
   *
   * @type {AdminRegion}
   * @memberof MarkRegionAvailable200Response
   */
  data: AdminRegion;
}

/**
 * Check if a given object implements the MarkRegionAvailable200Response interface.
 */
export function instanceOfMarkRegionAvailable200Response(
  value: object,
): value is MarkRegionAvailable200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function MarkRegionAvailable200ResponseFromJSON(
  json: any,
): MarkRegionAvailable200Response {
  return MarkRegionAvailable200ResponseFromJSONTyped(json, false);
}

export function MarkRegionAvailable200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkRegionAvailable200Response {
  if (json == null) {
    return json;
  }
  return {
    data: AdminRegionFromJSON(json['data']),
  };
}

export function MarkRegionAvailable200ResponseToJSON(
  json: any,
): MarkRegionAvailable200Response {
  return MarkRegionAvailable200ResponseToJSONTyped(json, false);
}

export function MarkRegionAvailable200ResponseToJSONTyped(
  value?: MarkRegionAvailable200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: AdminRegionToJSON(value['data']),
  };
}
